import { formTimeString } from '@24i/player-utils';

const HOUR = 1000 * 60 * 60;

export const formatPlayerTime = (timestamp: number) => formTimeString(timestamp, timestamp >= HOUR);
